import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';
import { useImportSheet } from '../app/ImportSheetProvider.tsx';
import { RecipeList } from '../features/recipes/RecipeList.tsx';

/**
 * `/import?url=…` (share targets, links): shows the recipes with the Import sheet open and the
 * link or text filled in.
 */
export const Route = createFileRoute('/import')({
  validateSearch: z.object({
    url: z.string().optional(),
    text: z.string().optional(),
    title: z.string().optional(),
  }),
  component: ImportRoute,
});

function ImportRoute() {
  const search = Route.useSearch();
  const sheet = useImportSheet();
  const navigate = useNavigate();
  useEffect(() => {
    const url = search.url ?? (search.text?.match(/https?:\/\/\S+/)?.[0] || undefined);
    sheet.open(url ? { url } : search.text ? { text: search.text } : undefined);
    void navigate({ to: '/recipes', replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- once per visit
  }, []);
  return <RecipeList />;
}
